// Medication Administration Record: list per client, dose outcomes, monthly grid.
import { supabase } from './supabase';
import { IN_SERVICE_STATUSES } from './serviceModel';

export const ROUTES = ['PO', 'G-tube', 'J-tube', 'Inhaled', 'Nebulized', 'Topical', 'Rectal', 'SubQ', 'IM', 'IV', 'Ophthalmic', 'Otic', 'Nasal'];
export const ADMIN_BY = [['nurse', 'Nurse (on the MAR)'], ['family', 'Family caregiver'], ['self', 'Self-administered']];
export const MED_STATUS = [['active', 'Active'], ['held', 'On hold'], ['discontinued', 'Discontinued']];
export const DOSE_STATUS = { given: 'Given', late: 'Given late', held: 'Held', refused: 'Refused', not_given: 'Not given' };

export const getClientMedications = (clientId, includeInactive = true) => {
  let q = supabase.from('client_medications').select('*').eq('client_id', clientId).order('status').order('name');
  if (!includeInactive) q = q.eq('status', 'active');
  return q;
};
export const saveMedication = (m) => m.id
  ? supabase.from('client_medications').update({ ...m, updated_at: new Date().toISOString() }).eq('id', m.id).select().single()
  : supabase.from('client_medications').insert([m]).select().single();
export const importMedsFromClient = async (clientId) => {
  const { data, error } = await supabase.rpc('mar_import_from_client', { p_client_id: clientId });
  if (error) throw new Error(error.message);
  return data;
};
export const reconcileMeds = async (clientId) => {
  const { error } = await supabase.rpc('mar_reconcile', { p_client_id: clientId });
  if (error) throw new Error(error.message);
};
export const getAdministrations = (clientId, fromIso, toIso) =>
  supabase.from('medication_administrations')
    .select('*, staff:staff ( first_name, last_name )')
    .eq('client_id', clientId)
    .or(`and(scheduled_for.gte.${fromIso},scheduled_for.lte.${toIso}),and(scheduled_for.is.null,given_at.gte.${fromIso},given_at.lte.${toIso})`)
    .order('scheduled_for');
export const recordDose = async (args) => {
  const { data, error } = await supabase.rpc('mar_record', {
    p_visit_id: args.visitId, p_medication_id: args.medicationId, p_scheduled_for: args.scheduledFor || null, p_status: args.status,
    p_given_at: args.givenAt || null, p_dose_given: args.doseGiven || null, p_reason: args.reason || null, p_note: args.note || null,
    p_effect: args.effect || null, p_administration_id: args.administrationId || null,
  });
  if (error) throw new Error(error.message);
  return data;
};

// Board: clients with nurse-administered meds, reconciliation age, exceptions this week.
export const getMarBoard = async () => {
  const weekAgo = new Date(Date.now() - 7 * 86400000).toISOString();
  const [{ data: clients }, { data: meds }, { data: adm }] = await Promise.all([
    supabase.from('clients').select('id, client_id, first_name, last_name, current_status, medications_reconciled_at, current_medications, allergies')
      .in('current_status', IN_SERVICE_STATUSES).order('last_name'),
    supabase.from('client_medications').select('client_id, status, administered_by, prn'),
    supabase.from('medication_administrations').select('client_id, status').gte('created_at', weekAgo),
  ]);
  const m = {}; (meds || []).forEach(x => { const b = m[x.client_id] = m[x.client_id] || { active: 0, nurse: 0, prn: 0 }; if (x.status === 'active') { b.active += 1; if (x.administered_by === 'nurse') b.nurse += 1; if (x.prn) b.prn += 1; } });
  const a = {}; (adm || []).forEach(x => { const b = a[x.client_id] = a[x.client_id] || { given: 0, exceptions: 0 }; if (['given', 'late'].includes(x.status)) b.given += 1; else b.exceptions += 1; });
  return (clients || []).map(c => ({ ...c, meds: m[c.id] || { active: 0, nurse: 0, prn: 0 }, week: a[c.id] || { given: 0, exceptions: 0 },
    hasFreeText: !!(c.current_medications && c.current_medications.trim() && !/^(none|n\/a|na)$/i.test(c.current_medications.trim())) }));
};
